import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiChip']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => ({
    '& > .MuiSvgIcon-root + .MuiChip-label': {
      paddingLeft: theme.spacing(0.75),
    },

    ...(ownerState.variant === 'outlined' &&
      ownerState.color === 'default' && {
        borderColor: theme.vars.palette.grey[200],
        color: theme.vars.palette.text.primary,
        '&:hover': {
          borderColor: theme.vars.palette.grey[300],
        },
      }),

    ...(ownerState.variant === 'outlined' &&
      ownerState.color !== 'default' &&
      ownerState.color && {
        borderColor: theme.vars.palette[ownerState.color]?.light,
        color: theme.vars.palette[ownerState.color]?.darkest,
        '&:hover': {
          borderColor: theme.vars.palette[ownerState.color]?.main,
        },
      }),

    ...(ownerState.variant === 'filled' &&
      ownerState.color === 'default' && {
        backgroundColor: theme.vars.palette.grey[200],
        color: theme.vars.palette.text.primary,
        '&:hover': {
          backgroundColor: theme.vars.palette.grey[300],
        },
        '& .MuiChip-deleteIcon': {
          color: theme.vars.palette.text.secondary,
        },
        '&:hover .MuiChip-deleteIcon': {
          color: theme.vars.palette.text.primary,
        },
      }),

    ...(ownerState.variant === 'filled' &&
      ownerState.color !== 'default' &&
      ownerState.color && {
        backgroundColor: theme.vars.palette[ownerState.color]?.main,
        color: theme.vars.palette[ownerState.color]?.contrastText,
        '&:hover': {
          backgroundColor: theme.vars.palette[ownerState.color]?.dark,
        },
      }),
  }),
};

const MuiChip: Components<CssVarsTheme>['MuiChip'] = {
  styleOverrides,
};

export default MuiChip;
